// src/App.js - Tách biệt StudentProvider khỏi các trang Công khai (Public Routes)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';

// Layout Wrappers
import Main from './Main';
import AdminManagement from './admin/AdminManagement';
import DisciplineBoard from './admin/DisciplineBoard';
import AdministrativeBoard from './admin/AdministrativeBoard';
import BlockLeaderManagement from './admin/BlockLeaderManagement';
import ProtectedRoute from './ProtectedRoute';
import { StudentProvider } from './StudentContext';

// Components Dành Cho Giáo Lý Viên & Admin
import QRScanner from './components/QRScanner';
import QRScannerClass from './components/QRScannerClass';
import BlockList from './components/BlockList';
import ClassList from './components/ClassList';
import ClassStudents from './components/ClassStudents';
import ClassTranscript from './components/ClassTranscript';
import Student from './components/Student';
import CatechistProfile from './components/CatechistProfile';

// Admin Sub-pages
import PrintCards from './admin/PrintCards';
import EarlyAttendanceStats from './admin/EarlyAttendanceStats';
import CatechistManager from './admin/CatechistManager';
import CatechistStatusManager from './admin/CatechistStatusManager';
import AddNewStudent from './admin/AddNewStudent';
import EventManager from './admin/EventManager';
import TranscriptManagement from './admin/TranscriptManagement';
import StudentManager from './admin/StudentManager';
import AttendanceLogManager from './admin/AttendanceLogManager';
import UpdateHolyName from './admin/UpdateHolyName';
import ChatbotManager from './admin/ChatbotManager';
import SupplementalAttendance from './admin/SupplementalAttendance';
import AttendanceAssignment from './admin/AttendanceAssignment';
import QuizStatistics from './admin/QuizStatistics';
import PrintTranscript from './admin/PrintTranscript';
import CatechistAttendanceManager from './admin/CatechistAttendanceManager';
import AcademicYearsManager from './admin/AcademicYearsManager';
import DataMigrationManager from './admin/DataMigration/DataMigrationManager';
import StudentPromotionManager from './admin/StudentPromotionManager';
import PrintClassList from './admin/PrintClassList';
// Import các Component
import CatechistLeaveRequests from './admin/CatechistLeaveRequests';

// Components Trang Công Khai (Public Pages - KHÔNG CẦN StudentContext)
import HomePage from './HomePage/Home';
import Events from './HomePage/Events';
import News from './HomePage/News';
import BibleQuiz from './HomePage/Game/BibleQuiz/BibleQuiz';
import FunLearn from './HomePage/FunLearn';
import ParentView from './components/ParentView';
import ParentStudentDetail from './components/ParentStudentDetail';
import Login from './Login';
import ChristmasEvent from './HomePage/ChristmasEvent';
import LotoScanner from './HomePage/LotoScanner';
import TetEvents from './HomePage/TetEvents';
import CatechistQRScanner from './components/CatechistQRScanner';
import LiturgyBoard from './admin/LiturgyBoard';
import Werewolf from './HomePage/Game/Werewolf/Werewolf';
import AdminTranscriptManager from './admin/AdminTranscriptManager';
import CatechistCurriculumVitaeManager from './admin/CatechistCurriculumVitaeManager';
import TuitionFeeManager from './admin/TuitionFeeManager';
import PrintTuitionList from './admin/PrintTuitionList';
import WhatToEat from './HomePage/WhatToEat';
import AttendanceDateManagement from './admin/AttendanceDateManagement';
import AllAttendanceManager from './admin/AllAttendanceManager';
import PrintDroppedOutStudents from './admin/PrintDroppedOutStudents';
import AdminCatechistGifts from './admin/AdminCatechistGifts';
import CatechistGiftRoulette from './components/CatechistGiftRoulette';
import ClassTransferHistory from './admin/ClassTransferHistory';
import CatechistSubstituteManager from './admin/CatechistSubstituteManager';
import TranscriptHistoryManager from './admin/TranscriptHistoryManager';

// 🌟 Wrapper Layout Nội Bộ: Chỉ bọc StudentProvider cho các tuyến đường Nội Bộ
const InternalLayout = () => (
  <StudentProvider>
    <Outlet />
  </StudentProvider>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* ========================================================= */}
        {/* 1. CÁC TRANG CÔNG KHAI (NO StudentProvider - Tối ưu 100% Băng thông) */}
        {/* ========================================================= */}
        <Route path="/" element={<HomePage />} />
        <Route path="/events" element={<Events />} />
        <Route path="/news" element={<News />} />
        <Route path="/bible-quiz" element={<BibleQuiz />} />
        <Route path="/fun-learn" element={<FunLearn />} />
        <Route path="/parent" element={<ParentView />} />
        <Route path="/parent/student/:studentId" element={<ParentStudentDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/christmas-event" element={<ChristmasEvent />} />
        <Route path="/loto-scanner" element={<LotoScanner />} />
        <Route path="/tet-events" element={<TetEvents />} />
        <Route path="/werewolf" element={<Werewolf />} />
        <Route path="/an-gi-hom-nay" element={<WhatToEat />} />
        {/* ========================================================= */}
        {/* 2. CÁC TRANG NỘI BỘ (CÓ StudentProvider Quản Lý Phân Quyền) */}
        {/* ========================================================= */}
        <Route element={<InternalLayout />}>

          {/* Dashboard Quản Trị Admin */}
          <Route path="/admin-management" element={<ProtectedRoute><AdminManagement /></ProtectedRoute>}>
            <Route index element={<Navigate to="print-cards" replace />} />
            <Route path="print-cards" element={<PrintCards />} />
            <Route path="early-attendance" element={<EarlyAttendanceStats />} />
            <Route path="academic-years" element={<AcademicYearsManager />} />
            <Route path="catechist-management" element={<CatechistManager />} />
            <Route path="catechist-status" element={<CatechistStatusManager />} />
            <Route path="transcript-management" element={<TranscriptManagement />} />
            <Route path="add-new-student" element={<AddNewStudent />} />
            <Route path="event-management" element={<EventManager />} />
            <Route path="student-management" element={<StudentManager />} />
            <Route path="class-transfer-history" element={<ClassTransferHistory />} />
            <Route path="attendance-log" element={<AttendanceLogManager />} />
            <Route path="update-holy-name" element={<UpdateHolyName />} />
            <Route path="chatbot-management" element={<ChatbotManager />} />
            <Route path="supplemental-attendance" element={<SupplementalAttendance />} />
            <Route path="print-transcripts" element={<PrintTranscript />} />
            <Route path="attendance-assignment" element={<AttendanceAssignment />} />
            <Route path="quiz-statistics" element={<QuizStatistics />} />
            <Route path="catechist-attendance" element={<CatechistAttendanceManager />} />
            <Route path="data-migration" element={<DataMigrationManager />} />
            <Route path="student-promotion" element={<StudentPromotionManager />} />
            <Route path="catechist-qr-scanner" element={<CatechistQRScanner />} />
            <Route path="all-transcripts" element={<AdminTranscriptManager />} />
            <Route path="transcript-management" element={<AdminTranscriptManager />} />
            <Route path="print-class-list" element={<PrintClassList />} />
            <Route path="catechist-cv" element={<CatechistCurriculumVitaeManager />} />
            <Route path="tuition-management" element={<TuitionFeeManager />} />
            <Route path="print-tuition-list" element={<PrintTuitionList />} />
            <Route path="attendance-dates" element={<AttendanceDateManagement />} />
            <Route path="all-attendance" element={<AllAttendanceManager />} />
            <Route path="print-dropped-out" element={<PrintDroppedOutStudents />} />
            <Route path="catechist-gifts" element={<AdminCatechistGifts />} />
            <Route path="catechist-substitutes" element={<CatechistSubstituteManager />} />
            <Route path="transcript-history" element={<TranscriptHistoryManager />} />
          </Route>

          {/* Ban Kỷ Luật */}
          <Route path="/discipline-board" element={<ProtectedRoute><DisciplineBoard /></ProtectedRoute>}>
            <Route index element={<Navigate to="early-attendance" replace />} />
            <Route path="early-attendance" element={<EarlyAttendanceStats />} />
            <Route path="attendance-assignment" element={<AttendanceAssignment />} />
            <Route path="catechist-qr-scanner" element={<CatechistQRScanner />} />
          </Route>

          {/* Ban Hành Chánh */}
          <Route path="/administrative-board" element={<ProtectedRoute><AdministrativeBoard /></ProtectedRoute>}>
            <Route index element={<Navigate to="early-attendance" replace />} />
            <Route path="early-attendance" element={<EarlyAttendanceStats />} />
            <Route path="add-new-student" element={<AddNewStudent />} />
            <Route path="print-transcripts" element={<PrintTranscript />} />
            <Route path="print-class-list" element={<PrintClassList />} />
            <Route path="tuition-management" element={<TuitionFeeManager />} />
            <Route path="print-tuition-list" element={<PrintTuitionList />} />
            <Route path="print-dropped-out" element={<PrintDroppedOutStudents />} />
          </Route>

          {/* Ban Phụng Vụ */}
          <Route path="/liturgy-board" element={<ProtectedRoute><LiturgyBoard /></ProtectedRoute>}>
            <Route index element={<Navigate to="early-attendance" replace />} />
            <Route path="early-attendance" element={<EarlyAttendanceStats />} />
          </Route>

          {/* Trưởng Khối */}
          <Route path="/blockleadermanagement" element={<BlockLeaderManagement />}>
            {/* Mặc định điều hướng về trang Điểm danh GLV */}
            <Route index element={<Navigate to="catechist-attendance" replace />} />

            {/* Tab 1: Màn hình Điểm danh GLV 3 Cột */}
            <Route path="catechist-attendance" element={<CatechistAttendanceManager />} />

            {/* Tab 2: Màn hình Duyệt Đơn Xin Nghỉ */}
            <Route path="leave-requests" element={<CatechistLeaveRequests />} />

            {/* 🌟 Tab 3: Màn hình Sơ Yếu Lý Lịch GLV (Chế độ chỉ xem cho Trưởng Khối) 🌟 */}
            <Route path="catechist-cv" element={<CatechistCurriculumVitaeManager />} />
          </Route>

          {/* Giao Diện Giáo Lý Viên */}
          <Route path="/main" element={<Main />}>
            <Route path="qr-scanner" element={<QRScanner />} />
            <Route path="qr-scanner-class" element={<QRScannerClass />} />
            <Route path="catechist-qr-scanner" element={<CatechistQRScanner />} />
            <Route path="class-list" element={<BlockList />}>
              <Route path=":blockId" element={<ClassList />}>
                <Route path=":classId" element={<ClassStudents />} />
              </Route>
            </Route>
            <Route path="class-transcript/:blockId/:classId" element={<ClassTranscript />} />
            <Route path="student/:studentId" element={<Student />} />
            <Route path="profile" element={<CatechistProfile />} />
            <Route index element={<Navigate to="qr-scanner" replace />} />
            <Route path="catechist-gift" element={<CatechistGiftRoulette />} />
          </Route>

        </Route>

        {/* Điều hướng đường dẫn không tồn tại về Trang chủ */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;